import React, { useState } from "react";
import { api } from "@/lib/api";
import { useAuth } from "@/contexts/AuthContext";
import { useNavigate } from "react-router-dom";
import { Sunrise, Check } from "lucide-react";

const TIMES = [
    { v: "05:00", l: "5:00 AM — Dawn" },
    { v: "06:00", l: "6:00 AM — Morning" },
    { v: "12:00", l: "12:00 PM — Midday Angelus" },
    { v: "15:00", l: "3:00 PM — Divine Mercy Hour" },
    { v: "18:00", l: "6:00 PM — Evening Angelus" },
    { v: "21:00", l: "9:00 PM — Night" },
];

export default function JoinWarriors() {
    const { user, refreshMe } = useAuth();
    const navigate = useNavigate();
    const [time, setTime] = useState(user?.prayer_time || "06:00");
    const [done, setDone] = useState(false);

    const submit = async (e) => {
        e.preventDefault();
        if (!user?.id) { navigate("/login"); return; }
        await api.post("/warriors/join", { prayer_time: time });
        await refreshMe();
        setDone(true);
        setTimeout(() => navigate("/dashboard"), 1500);
    };

    return (
        <div className="parchment min-h-[calc(100vh-4rem)]">
            <div className="mx-auto max-w-4xl px-6 md:px-10 py-16">
                <div className="text-xs tracking-[0.28em] uppercase" style={{ color: "#7F1D1D" }}>The Prayer Warriors</div>
                <h1 className="font-display text-4xl sm:text-5xl mt-2" style={{ color: "#1E1B4B" }}>
                    Commit an hour. Pray. Tell the centre.
                </h1>
                <p className="mt-4 max-w-2xl" style={{ color: "#525252" }}>
                    Members of the Prayer Warriors are given guidance and spiritual accompaniment. Choose an hour of the day for your prayer. You will be notified when intentions are shared, and a short note from you lets the Requester know they are remembered.
                </p>

                <form onSubmit={submit} className="mt-10 p-card p-6 sm:p-8" data-testid="warriors-form">
                    <label className="block text-xs uppercase tracking-[0.22em] mb-3" style={{ color: "#7F1D1D" }}>Preferred hour for prayer</label>
                    <div className="grid sm:grid-cols-2 gap-2.5">
                        {TIMES.map((t) => (
                            <button type="button" key={t.v} onClick={() => setTime(t.v)}
                                    className={`p-card p-3 text-left flex items-center gap-3 ${time === t.v ? "" : ""}`}
                                    style={{ borderColor: time === t.v ? "#D4AF37" : "#E5E0D8" }}
                                    data-testid={`warriors-time-${t.v}`}>
                                <div className="h-9 w-9 rounded-full flex items-center justify-center"
                                     style={{ background: time === t.v ? "#1E1B4B" : "#F5F0E6", color: time === t.v ? "#D4AF37" : "#7F1D1D" }}>
                                    <Sunrise size={16} />
                                </div>
                                <div className="font-display text-base" style={{ color: "#1E1B4B" }}>{t.l}</div>
                            </button>
                        ))}
                    </div>
                    <button type="submit" className="mt-6 btn-primary" data-testid="warriors-submit-button">
                        {user?.is_warrior ? "Update my hour" : "Enroll me"}
                    </button>
                    {done && (
                        <div className="mt-3 text-sm flex items-center gap-1" style={{ color: "#7F1D1D" }} data-testid="warriors-success">
                            <Check size={14} /> Welcome, Prayer Warrior.
                        </div>
                    )}
                </form>
            </div>
        </div>
    );
}
